import {
  REQUEST_COMPANIES,
  RECEIVE_COMPANIES,
  FAILED_COMPANIES,
} from "../../constants/actionTypes";

const companies = (state = {}, action) => {
  switch (action.type) {
    case REQUEST_COMPANIES:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_COMPANIES:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case FAILED_COMPANIES:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default companies;
